import { provideChameleonDesignSystem } from '../provideChameleonDesignSystem';
import { chameleonAlert, chameleonAlertV2 } from './Alert.definition';
import { chameleonSvg } from '../Svg';
import { chameleonIconButton } from '../IconButton/IconButton.definition';
export function registerCustom(prefix, node) {
    return provideChameleonDesignSystem({ prefix, node }).register(chameleonAlert({ prefix }), chameleonAlertV2({ prefix }), chameleonSvg({ prefix }), chameleonIconButton({ prefix }));
}
